import {
    Grid
} from "@material-ui/core";
import axios from "axios";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import AddIcon from '@mui/icons-material/Add';
import { Backdrop, Fade, Modal, CircularProgress } from '@mui/material';
import { SERVER_IP, PrimaryColor } from "../../variables";
import { Sidebar } from "../Sidebar";
import EditIcon from '@mui/icons-material/Edit';
import { Box, Paper, Toolbar, Typography, TextField } from '@mui/material';
import Button from '@mui/lab/LoadingButton';
import { dateFormat, getCurrentUserID, getDateTime, inputFieldVariant, isSuperUser } from "../../utils";
import TablePlaceholder from "../TablePlaceholder";

const modalStyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    maxWidth: '90%',
    maxHeight: '90vh'
};

export const CertificateType = () => {

    const [loading, setLoading] = useState(false)
    const [addButtonClicked, setAddButtonClicked] = useState(false)
    const [editButtonClicked, setEditButtonClicked] = useState(false)
    const [pageSize, setPageSize] = useState(5)
    const [modalKey, setModalKey] = useState(0);
    const [certificateTypes, setCertificateTypes] = useState<Array<any>>([]);
    const [newName, setNewName] = useState<any>("");
    const [selectedCertificateType, setSelectedCertificateType] = useState<any>({
        CertTypeID: "",
        CertTypeName: ""
    });


    const columns: GridColDef[] = [
        {
            field: 'CertTypeID',
            headerName: 'ID',
            width: 200,
            renderCell: (row) => row.value || "NA"
        },
        {
            field: 'CertTypeName',
            headerName: 'Certificate Type Name',
            width: 200,
            editable: true,
            flex: 1,
            renderCell: (row) => row.value || "NA"
        },
        {
            headerName: 'Added On',
            field: 'AddedDateTime',
            width: 200,
            renderCell: (row) => row.value ? dateFormat(row.value) : "NA"
        },
        {
            field: 'Action',
            headerName: 'Action Buttons',
            sortable: false,
            filterable: false,
            width: 300,
            hide: !isSuperUser(),
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => {
                return (
                    <div key={row.id} style={{ display: 'flex' }}>
                        <Button
                            color="primary"
                            size="small"
                            variant="contained"
                            style={{ marginTop: '15px', marginRight: '15px' }}
                            startIcon={<EditIcon />}
                            onClick={() => {
                                setSelectedCertificateType(row.row)
                                setEditButtonClicked(true)
                            }}
                        >
                            Edit
                        </Button>
                        <Button
                            color="error"
                            size="small"
                            variant="contained"
                            style={{ marginTop: '15px' }}
                            onClick={() => {
                                if (window.confirm("Are You Sure?")) {
                                    deleteCertificateType(row.id)
                                }
                            }}
                        >
                            Delete
                        </Button>
                    </div>
                )
            }
        },
    ];

    const getCertificateTypes = () => {
        setLoading(true)
        axios
            .get(`${SERVER_IP}certificatetype`)
            .then((res) => {
                setCertificateTypes(res.data);
            }).catch((err) => {
                console.log(err)
            }).finally(() => setLoading(false))
    };

    const createCertificateType = () => {
        if (!newName) {
            toast.error("Enter a Name")
            return
        }
        setLoading(true)
        let temp = {
            CertTypeName: newName,
            AddedByUserID: getCurrentUserID(),
            AddedDateTime: getDateTime(),
        }
        axios
            .post(
                `${SERVER_IP}certificatetype`,
                temp
            )
            .then((res) => {
                toast.success("Created Successfully!");
                getCertificateTypes()
            })
            .catch((err) => {
                console.log(err)
                toast.error("Creation Failed!");
            }).finally(() => {
                setLoading(false)
                setAddButtonClicked(false)
            })
    };

    const updateCertificateType = async () => {

        if (!selectedCertificateType.CertTypeName) {
            toast.error("Enter a Name")
            return
        }

        setLoading(true)
        let temp = {
            ...selectedCertificateType,
            AddedByUserID: getCurrentUserID(),
            AddedDateTime: getDateTime(),
        }
        // console.log(temp)
        axios.put(`${SERVER_IP}certificatetype`, temp)
            .then((res) => {
                toast.success("Updated Successfully!");
                getCertificateTypes()
            })
            .catch((res) => {
                toast.error("Updation Failed!");
            }).finally(() => {
                handleModalClose()
                setLoading(false)
            })

    }

    const deleteCertificateType = async (id) => {
        setLoading(true)
        axios.delete(`${SERVER_IP}certificatetype?CertTypeID=${id}`)
            .then((res) => {
                toast.success("Deleted Successfully!");
                getCertificateTypes()
            })
            .catch((res) => {
                toast.error("Couldn't Delete!");
            }).finally(() => setLoading(false))
    }

    const handleModalClose = () => {
        setAddButtonClicked(false)
        setEditButtonClicked(false)
    }

    useEffect(() => {
        getCertificateTypes();
    }, []);

    return (
        <>
            <div style={{ marginTop: 80, display: 'flex' }}>
                <Sidebar />
                <Grid container spacing={1} style={{ padding: '10px 30px 10px 30px' }}>
                    <Grid container spacing={3} style={{ margin: '10px auto', borderRadius: '10px', border: `2px solid ${PrimaryColor}` }}>

                        <Grid container style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                            <Box sx={{ width: '100%' }}>
                                {(loading) ?
                                    <TablePlaceholder />
                                    :
                                    <div style={{ padding: '10px 20px' }}>
                                        <Paper style={{ width: '100%', borderRadius: '10px', overflowX: 'auto' }}>
                                            <Toolbar
                                                sx={{
                                                    pl: { sm: 2 },
                                                    pr: { xs: 1, sm: 1 },
                                                    backgroundColor: '#d9dffd',
                                                }}
                                            >
                                                <Typography
                                                    sx={{ flex: '1 1 50%' }}
                                                    variant="h6"
                                                    id="tableTitle"
                                                    component="div"
                                                >
                                                    Certificate Types
                                                </Typography>
                                                <Typography
                                                    sx={{ marginLeft: 'auto' }}
                                                >
                                                    <Button
                                                        color="success"
                                                        size="small"
                                                        variant="contained"
                                                        onClick={() => setAddButtonClicked(true)}
                                                        startIcon={<AddIcon />}
                                                    >
                                                        Add New Cert Type
                                                    </Button>
                                                </Typography>
                                            </Toolbar>
                                            <Box
                                                sx={{
                                                    '& .MuiDataGrid-columnHeaders': {
                                                        backgroundColor: PrimaryColor,
                                                        color: 'white'
                                                    },
                                                }}
                                            >
                                                <DataGrid
                                                    autoHeight
                                                    getRowId={(row) => row.CertTypeID}
                                                    rows={certificateTypes}
                                                    columns={columns}
                                                    pageSize={pageSize}
                                                    rowsPerPageOptions={[5, 10, 15, certificateTypes.length > 100 ? 100 : certificateTypes.length]}
                                                    // checkboxSelection
                                                    disableSelectionOnClick
                                                    onPageSizeChange={(size) => setPageSize(size)}
                                                />
                                            </Box>

                                        </Paper>

                                    </div>
                                }
                                <ToastContainer />
                            </Box>

                        </Grid>

                        <ToastContainer />
                    </Grid>
                </Grid>

                <Modal
                    open={editButtonClicked}
                    onClose={handleModalClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                    key={modalKey}
                >
                    <Fade in={editButtonClicked}>
                        <Box sx={modalStyle}>
                            <Grid
                                container
                                spacing={3}
                                style={{
                                    margin: "10px auto",
                                    borderRadius: "10px",
                                }}
                            >
                                <Grid item xs={12}>
                                    <Typography
                                        style={{ backgroundColor: PrimaryColor, color: "white" }}
                                        variant="h4"
                                        gutterBottom
                                    >
                                        {"Update Certificate Type"}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label="Certificate ID"
                                        variant={inputFieldVariant}
                                        value={selectedCertificateType.CertTypeID}
                                        fullWidth
                                        disabled
                                    />

                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label="Certificate Type Name"
                                        variant={inputFieldVariant}
                                        value={selectedCertificateType.CertTypeName}
                                        fullWidth
                                        required
                                        onChange={(e) => setSelectedCertificateType({
                                            ...selectedCertificateType,
                                            CertTypeName: e.target.value
                                        })}
                                    />

                                </Grid>
                                <Grid container style={{ marginBottom: '10px' }}>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        style={{ textAlign: "center" }}
                                    >
                                        <Button
                                            disabled={loading}
                                            color="primary"
                                            size="small"
                                            variant="contained"
                                            onClick={() => updateCertificateType()}
                                        >
                                            {loading && <CircularProgress size={20} style={{ marginRight: '10px' }} />}
                                            Update
                                        </Button>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        style={{ textAlign: "center" }}
                                    >
                                        <Button
                                            color="secondary"
                                            size="small"
                                            variant="contained"
                                            onClick={(e) => handleModalClose()}>
                                            Cancel
                                        </Button>
                                    </Grid>

                                </Grid>
                            </Grid>

                        </Box>
                    </Fade>
                </Modal>


                <Modal
                    open={addButtonClicked}
                    onClose={handleModalClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                    key={modalKey}
                >
                    <Fade in={addButtonClicked}>
                        <Box sx={modalStyle}>
                            <Grid
                                container
                                spacing={3}
                                style={{
                                    margin: "10px auto",
                                    borderRadius: "10px",
                                }}
                            >
                                <Grid item xs={12}>
                                    <Typography
                                        style={{ backgroundColor: PrimaryColor, color: "white" }}
                                        variant="h4"
                                        gutterBottom
                                    >
                                        {"Add Certificate Type"}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        label="Certificate Type Name"
                                        variant={inputFieldVariant}
                                        value={newName}
                                        fullWidth
                                        required
                                        onChange={(e) => setNewName(e.target.value)}
                                    />

                                </Grid>
                                <Grid container style={{ marginBottom: '10px' }}>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        style={{ textAlign: "center" }}
                                    >
                                        <Button
                                            disabled={loading}
                                            color="primary"
                                            size="small"
                                            variant="contained"
                                            onClick={() => createCertificateType()}
                                        >
                                            {loading && <CircularProgress size={20} style={{ marginRight: '10px' }} />}
                                            Add
                                        </Button>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        style={{ textAlign: "center" }}
                                    >
                                        <Button
                                            color="secondary"
                                            size="small"
                                            variant="contained"
                                            onClick={(e) => handleModalClose()}>
                                            Cancel
                                        </Button>
                                    </Grid>

                                </Grid>
                            </Grid>

                        </Box>
                    </Fade>
                </Modal>


            </div>
        </>

    );
};
